import React from "react";
import { Box } from "@mui/material";

import SalaryList from "./Salary/SalaryList";

// eslint-disable-next-line import/prefer-default-export
export function PayrollDashboard(): React.ReactNode {
  return (
    <Box>
      <SalaryList />
    </Box>
  );
}
